import { useEffect, useState } from "react";
import styles from "./styles/style.module.scss";
import AssignCandidate from "./components/assignCandidate";
import TrainingSessionDetails from "./components/trainingSessionDetails";
import Footer from "../footer";

import { useParams } from "react-router-dom";
import { functionService } from "../../lib/functions";
import moment from "moment";
const initialSessionData = {
  title: "",
  startDateTime: moment().format(),
  duration: null,
  meetingLink: "",
  teacherName: "",
};

const initalTrainingData = {
  title: "",
  duration: null,
  durationType: "week",
  discordLink: "",
  contentLink: "",
  maximumSeats: null,
  availableSeats: null,
  registrationLink: "",
  description: "",
  role: "",
  alternateName: "",
  imageLink: "",
  sessions: [initialSessionData],
  emails: [],

  meetingKey: "",
  platformType: "",
  instanceId: "",
  trainingRecordingLink: "",
};
const AddTraining = ({ type }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [trainingData, setTrainingData] = useState(initalTrainingData);
  const [imageUpdate, setImageUpdated] = useState(false);

  let { id } = useParams();

  const getCurrentTrainingDetails = async ({ currentTrainingId }) => {
    let { response } = await functionService.get(
      `training/${currentTrainingId}`
    );
    if (response) {
      const latestTrainingData = {
        ...response?.data?.data?.training,
        sessions: response?.data?.data?.sessions,
        emails: response?.data?.data?.students.map(({ email, id }) => {
          return { email, id };
        }),
        imageLink: response?.data?.data?.training?.imageLink,
      };

      setTrainingData(latestTrainingData);
    }
  };

  useEffect(() => {
    if (id) {
      getCurrentTrainingDetails({
        currentTrainingId: id,
      });
    }
  }, [id]);

  return (
    <>
      <div
        style={{ height: "100vh", overflow: "scroll" }}
        className={styles.training}
      >
        <div className={styles.scheduleHeading}>
          {type === "EDIT" ? "Edit Training" : "Schedule Training Sessions"}
        </div>
        <div className={styles.sessionsBox}>
          <div className={styles.assignCandidateHeading}>
            <div className={styles.stepLevel}>
              <div
                className={styles.one}
                style={{
                  color: currentStep === 1 ? "#21C17A" : "#1B49EA",
                  backgroundColor:
                    currentStep === 1 ? "rgba(33, 193, 122, 0.2)" : "#EDF0FD",
                }}
              >
                1
              </div>
              <div
                className={styles.three}
                style={{
                  color: currentStep === 2 ? "#21C17A" : "#1B49EA",
                  backgroundColor:
                    currentStep === 2 ? "rgba(33, 193, 122, 0.2)" : "#EDF0FD",
                }}
              >
                2
              </div>
              <div className={styles.dashedLine} />
            </div>
            <div className={styles.stepLabels}>
              <div
                style={{
                  fontWeight: currentStep === 1 ? 700 : 300,
                  color: currentStep === 1 ? "#21C17A" : "#1E2228",
                }}
              >
                Training Sessions
              </div>
              <div
                style={{
                  fontWeight: currentStep === 2 ? 700 : 300,
                  color: currentStep === 2 ? "#21C17A" : "#1E2228",
                }}
              >
                Assign Candidates
              </div>
            </div>
          </div>
          {currentStep === 1 && (
            <TrainingSessionDetails
              setImageUpdated={setImageUpdated}
              type={type}
              setCurrentStep={setCurrentStep}
              setTrainingData={setTrainingData}
              trainingData={trainingData}
            />
          )}
          {currentStep === 2 && (
            <AssignCandidate
              imageUpdate={imageUpdate}
              type={type}
              setCurrentStep={setCurrentStep}
              setTrainingData={setTrainingData}
              trainingData={trainingData}
            />
          )}
        </div>
        <Footer />
      </div>
    </>
  );
};

export default AddTraining;
